import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import _ from 'lodash';
import Link from '../../../components/Link/Link';
import CourseReviewForm from '../CourseReviewForm/CourseReviewForm';
import s from './CongratulationsModal.scss';
var messages = defineMessages({
  viewCertificateBtn: {
    id: "CongratulationsModal.viewCertificateBtn",
    defaultMessage: [{
      "type": 0,
      "value": "View certificate"
    }]
  },
  backToIndexBtn: {
    id: "CongratulationsModal.backToIndexBtn",
    defaultMessage: [{
      "type": 0,
      "value": "Back to index"
    }]
  },
  text: {
    id: "CongratulationsModal.text",
    defaultMessage: [{
      "type": 0,
      "value": "Congratulations, "
    }, {
      "type": 1,
      "value": "courseName"
    }, {
      "type": 0,
      "value": " completed, your certificate will appear on profile page in couple of minutes!"
    }]
  }
});
var CongratulationsModal = function CongratulationsModal(_ref) {
  var onClose = _ref.onClose,
    course = _ref.course,
    _ref$hideCertificateB = _ref.hideCertificateBtn,
    hideCertificateBtn = _ref$hideCertificateB === void 0 ? false : _ref$hideCertificateB;
  var _useState = useState(course.type === 'normal'),
    _useState2 = _slicedToArray(_useState, 2),
    showCourseReview = _useState2[0],
    setShowCourseReview = _useState2[1];
  return /*#__PURE__*/_jsx("div", {
    className: s.paper,
    "data-test": "congratulations-modal"
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    className: s.text,
    variant: "subtitle1"
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.text, {
    values: {
      courseName: course.name
    }
  }))), /*#__PURE__*/_jsx("div", {
    className: s.partyIcon
  }), showCourseReview ? /*#__PURE__*/_jsx(CourseReviewForm, {
    isCongratsModal: true,
    handleClose: function handleClose() {
      return setShowCourseReview(false);
    }
  }) : /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Button, {
    variant: "outlined",
    color: "primary",
    "data-test": "back-to-index-btn",
    component: Link,
    to: "/",
    className: s.backToIndexBtn
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.backToIndexBtn)), !hideCertificateBtn && /*#__PURE__*/_jsx(Button, {
    variant: "outlined",
    color: "secondary",
    id: "view-certificate-btn",
    component: Link,
    to: "/cert/".concat(_.get(course, 'certificate.code', '')),
    className: s.viewCertificateBtn
  }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.viewCertificateBtn))), /*#__PURE__*/_jsx("div", {
    className: s.closeModalBtn
  }, void 0, /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "SB_C1RStvzbKP5EnegBFP",
    onClick: onClose,
    "data-test": "close-congratulations-btn"
  }, void 0, /*#__PURE__*/_jsx(CloseIcon, {
    className: s.closeIcon
  }))));
};
export default injectIntl(withStyles(s)(CongratulationsModal));